import React from 'react';
import '../assets/css/normalize.css';
import '../assets/css/main.css';
import '../assets/css/google.fonts.css'
import useAppInit from '../consumer/init/useAppInit';
import LoadingPage from './cmp/loading/LoadingPage';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import AppMain from './AppMain';
import AgenturKontaktDialog from "./agentur/kontakt/AgenturKontakt";
import useAppCtx from '../app/ctx-provider/useAppCtx';

const useStyles = makeStyles((theme: Theme) => createStyles({
    wrapper: {
        height: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    header: {
        position: "fixed",
        top: 0,
        zIndex: theme.zIndex.appBar,
        width: '100%',
        background: '#cce4f0',
    },

    main: {

        width: '100%',
        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            marginTop: 120,
        },

        // sm, extra-small: (min-width: 600px)
        [theme.breakpoints.up('sm')]: {
            marginTop: 120,
        },
        
        // md (min-width: 960px)
        [theme.breakpoints.up('md')]: {
            marginTop: 120,
        },

        flexGrow: 1,
    },
    footer: {
        background: '#a4cade',
        paddingTop: 10,
        width: '100%',
    },

}));

const App: React.FC<{ jwt?: string }> = ({ jwt }) => {
    const classes = useStyles();
    const { appCtxBo } = useAppCtx();
    const { loading } = useAppInit(jwt);
    
    const isDogorama:boolean = appCtxBo.abTestVersion === 'c';

    const renderContent = () => {
        return (
            <div className={classes.wrapper}>

                <header className={classes.header} >
                    <AppHeader />
                </header>

                <main className={(isDogorama ? classes.main+" dogorama" : classes.main)}>
                    <AgenturKontaktDialog />
                    <AppMain />
                </main>

                <footer className={classes.footer}>
                    <AppFooter />
                </footer>

            </div>
        )
    };

    return (
        <div style={{ height: '100%', minHeight: '100%', width: '100%' }}>
            {loading === true ? <LoadingPage /> : renderContent()}
        </div >
    );
}

export default App;